import { useEffect, useState } from "react";
import { Download, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
  window.dispatchEvent(new Event("pwa-installable"));
});

export const InstallApp = ({ className = "" }) => {
  const [canPrompt, setCanPrompt] = useState(!!deferred);
  const [installed, setInstalled] = useState(isStandalone());
  const [help, setHelp] = useState(false);

  useEffect(() => {
    const on = () => setCanPrompt(true);
    const done = () => setInstalled(true);
    window.addEventListener("pwa-installable", on);
    window.addEventListener("appinstalled", done);
    return () => {
      window.removeEventListener("pwa-installable", on);
      window.removeEventListener("appinstalled", done);
    };
  }, []);

  if (installed || (!canPrompt && !isIOS())) return null;

  const install = async () => {
    if (!deferred) return setHelp(true);
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    setCanPrompt(false);
    if (outcome === "accepted") setInstalled(true);
  };

  return (
    <>
      <button type="button" onClick={install} title="Installa l'app" className={`inline-flex items-center gap-1.5 rounded-full border border-white/25 px-3 py-1.5 text-xs font-medium uppercase tracking-wider hover:bg-white/10 transition-colors ${className}`} data-testid="install-app-button">
        <Download className="h-4 w-4" />Installa app
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid="install-app-ios-dialog">
          <DialogHeader>
            <DialogTitle>Installa l'app su iPhone o iPad</DialogTitle>
            <DialogDescription>Aggiungi la web app alla schermata Home in due passaggi con Safari.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Share className="h-5 w-5 text-emerald-700 shrink-0" />1. Tocca il pulsante Condividi nella barra di Safari</li>
            <li className="flex items-center gap-2"><PlusSquare className="h-5 w-5 text-emerald-700 shrink-0" />2. Scegli "Aggiungi alla schermata Home" e conferma</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
